import { render, staticRenderFns } from "./QRCodes.vue?vue&type=template&id=8e25f964&scoped=true"
import script from "./QRCodes.vue?vue&type=script&lang=js"
export * from "./QRCodes.vue?vue&type=script&lang=js"
import style0 from "./QRCodes.vue?vue&type=style&index=0&id=8e25f964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e25f964",
  null
  
)

export default component.exports